import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import { get } from 'lodash';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import AnyButton from '../../components/atoms/AnyButton';
import { countPreShopName, countPreShopPhone } from '../../actions/PreShops';
import { getZipCode } from '../../actions/Shop';
import ShopAddConfirm from './ShopAddConfirm';
import FileUpload from '../../components/molecules/FileUpload';
import { getOptionCities } from '../../actions/Cities';

const styles = theme => ({
  root: {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    backgroundColor: '#fff',
    padding: 0,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  mainPaper: {
    boxShadow: 'none'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px',
    fontSize: 14
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px',
    height: '4px'
  },
  textField: {
    padding: 0,
    width: '100%'
  },
  editTable: {
    width: 'auto',
    display: 'block',
    '& tr': {
      display: 'block'
    }
  },
  tableCell90: {
    width: '90%',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  depositManageDiv: {
    paddingTop: '1.5rem'
  },
  depositManageInfo: {
    paddingTop: '1.5rem',
    color: 'red',
    fontWeight: 'bold'
  },
  discription: {
    fontSize: '0.875rem'
  },
  note: {
    padding: '10px'
  },
  tagCaution: {
    color: 'red',
    fontWeight: 'bold',
    textDecoration: 'underline'
  },
  desEmail: {
    color: 'red',
    fontWeight: 500
  },
  marginBottom10: {
    marginBottom: '10px'
  },
  colLeft: {
    paddingLeft: 20,
    paddingRight: 20,
    display: 'block',
    border: 0,
    paddingBottom: 5
  },
  colRight: {
    paddingLeft: 20,
    paddingRight: 20,
    display: 'block',
    border: 0,
    paddingTop: 0
  },
  hideMobile: {
    display: 'none'
  },
  modalMobile: {
    maxWidth: 375,
    margin: 'auto',
    padding: '5% 10px 5%'
  },
  font12: {
    fontSize: 12
  },
  clsActions: {
    padding: 20
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      prefectures: state.commons.prefectures,
      cities: state.cities.listCities,
      detail: state.preShops.detail,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        { countPreShopName, countPreShopPhone, getOptionCities, getZipCode },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('preShopId', 'setPreShopId', null),
  withState('unregistered', 'setUnregistered', false),
  withState('shopName', 'setShopName', ''),
  withState('shopNameError', 'setShopNameError', ''),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('shopNameKanaError', 'setShopNameKanaError', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('zipCodeError', 'setZipCodeError', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefecturesError', 'setPrefecturesError', ''),
  withState('city', 'setCity', ''),
  withState('cityError', 'setCityError', ''),
  // withState('cityName', 'setCityName', ''),
  // withState('cityNameError', 'setCityNameError', ''),
  withState('cityIdError', 'setCityIdError', ''),
  withState('address', 'setAddress', ''),
  withState('addressError', 'setAddressError', ''),
  withState('address1', 'setAddress1', ''),
  withState('address1Error', 'setAddress1Error', ''),
  withState('address2', 'setAddress2', ''),
  withState('address2Error', 'setAddress2Error', ''),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('contactPhone', 'setContactPhone', ''),
  withState('contactPhoneError', 'setContactPhoneError', ''),
  withState('phone', 'setPhone', ''),
  withState('phoneError', 'setPhoneError', ''),
  withState('introduction', 'setIntroduction', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('priceRange', 'setPriceRange', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('shopContactNameError', 'setShopContactNameError', ''),
  withState('shopGroupNameError', 'setShopGroupNameError', ''),
  withState('departmentError', 'setDepartmentError', ''),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('allowMenuPriceShashoku', 'setAllowMenuPriceShashoku', 0),
  withState('tagStr', 'setTagStr', props =>
    props.detail.tags
      .map(tag => {
        return `${tag.tagName}`;
      })
      .join(' ')
  ),
  withState('tags', 'setTags', null),
  withState('tagError', 'setTagError', ''),
  withState('images', 'setImages', null),
  withState('image1', 'setImage1', null),
  withState('previewImage1', 'setPreviewImage1', null),
  withState('image2', 'setImage2', null),
  withState('previewImage2', 'setPreviewImage2', null),
  withState('image3', 'setImage3', null),
  withState('previewImage3', 'setPreviewImage3', null),
  withState('image4', 'setImage4', null),
  withState('previewImage4', 'setPreviewImage4', null),
  withState('image5', 'setImage5', null),
  withState('previewImage5', 'setPreviewImage5', null),
  withState('stealthMode', 'setStealthMode', 'UNSTEALTH'),
  withState('stealthModeStr', 'setStealthModeStr', '表示'),
  withState('gochiRestriction', 'setGochiRestriction', 'MENTION_ONLY'),
  withState('gochiRestrictionStr', 'setGochiRestrictionStr', '指名ごちのみ'),
  withState('depositManage', 'setDepositManage', 'SELF'),
  withState('inviteUser', 'setInviteUser', ''),
  withState(
    'depositManageStr',
    'setDepositManageStr',
    'Stripe経由で受取（週1回入金）'
  ),
  withState('bankName', 'setBankName', ''),
  withState('bankNameError', 'setBankNameError', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankBranchNameError', 'setBankBranchNameError', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountNumberError', 'setBankAccountNumberError', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('bankAccountHolderError', 'setBankAccountHolderError', ''),
  withState('cognitoUserId', 'setCognitoUserId', ''),
  withState('forcePassChanged', 'setForcePassChanged', false),
  withState('consent', 'setConsent', false),
  withState('consentStep2', 'setConsentStep2', false),
  withState('shopCategoryId', 'setShopCategoryId', 0),
  withState('shopCategoriesError', 'setShopCategoriesError', ''),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('snsFacebook', 'setSnsFacebook', ''),
  withState('snsTwitter', 'setSnsTwitter', ''),
  withState('snsInstagram', 'setSnsInstagram', ''),
  withState('snsFacebookError', 'setSnsFacebookError', ''),
  withState('snsTwitterError', 'setSnsTwitterError', ''),
  withState('snsInstagramError', 'setSnsInstagramError', ''),
  withState('showPhone', 'setShowPhone', 1),
  withState('showRequire', 'setShowRequire', true),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionCities();
      this.props.setPreShopId(this.props.detail.preShopId);
      this.props.setUnregistered(
        typeof this.props.detail.unregistered !== 'undefined'
          ? this.props.detail.unregistered
          : true
      );
      this.props.setShopName(
        this.props.detail.preShopName ? this.props.detail.preShopName : ''
      );
      this.props.setZipCode(
        this.props.detail.zipCode ? this.props.detail.zipCode : ''
      );
      this.props.setPrefectureCode(
        this.props.detail.prefectureCode ? this.props.detail.prefectureCode : 0
      );
      this.props.setCity(this.props.detail.city ? this.props.detail.city : '');
      this.props.setAddress(
        this.props.detail.address ? this.props.detail.address : ''
      );
      this.props.setAddress1(
        this.props.detail.address1 ? this.props.detail.address1 : ''
      );
      this.props.setAddress2(
        this.props.detail.address2 ? this.props.detail.address2 : ''
      );
      this.props.setBuilding(
        this.props.detail.building ? this.props.detail.building : ''
      );
      this.props.setPhone(
        this.props.detail.phone ? this.props.detail.phone : ''
      );
      this.props.setBusinessHours(
        this.props.detail.businessHours ? this.props.detail.businessHours : ''
      );
      this.props.setHoliday(
        this.props.detail.holiday ? this.props.detail.holiday : ''
      );
      this.props.setAccess(
        this.props.detail.access ? this.props.detail.access : ''
      );
      this.props.setCashAllowed(get(this.props.detail, 'cashAllowed', 0));
      this.props.setAllowMenuPriceShashoku(
        get(this.props.detail, 'allowMenuPriceShashoku', 0)
      );
      this.props.setWebPage(
        this.props.detail.webPage ? this.props.detail.webPage : ''
      );
      this.props.setTags(this.props.detail.tags);
      this.props.setPreviewImage1(
        this.props.detail.images[0] ? this.props.detail.images[0].image : null
      );
      this.props.setPreviewImage2(
        this.props.detail.images[1] ? this.props.detail.images[1].image : null
      );
      this.props.setPreviewImage3(
        this.props.detail.images[2] ? this.props.detail.images[2].image : null
      );
      this.props.setPreviewImage4(
        this.props.detail.images[3] ? this.props.detail.images[3].image : null
      );
      this.props.setPreviewImage5(
        this.props.detail.images[4] ? this.props.detail.images[4].image : null
      );
      this.props.setShopCategoryId(
        this.props.detail.shopCategoryId ? this.props.detail.shopCategoryId : 0
      );
      if (this.props.detail.paymentGroupType) {
        this.props.setDepositManage('NOT_MANAGE');
      }
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    detail,
    openShopAddConfirm,
    cancelAction,
    backAction,
    registerAction,
    preShopId,
    unregistered,
    shopId,
    shopName,
    setShopName,
    shopNameKana,
    setShopNameKana,
    zipCode,
    setZipCode,
    prefectures,
    prefectureCode,
    setPrefectureCode,
    cities,
    city,
    setCity,
    // address,
    // setAddress,
    address1,
    setAddress1,
    address2,
    setAddress2,
    cityId,
    // cityName,
    // setCityName,
    setCityId,
    building,
    setBuilding,
    shopGroupName,
    setShopGroupName,
    shopContactName,
    setShopContactName,
    department,
    setDepartment,
    contactPhone,
    setContactPhone,
    phone,
    setPhone,
    introduction,
    setIntroduction,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    nearestStation,
    setNearestStation,
    priceRange,
    setPriceRange,
    access,
    setAccess,
    webPage,
    setWebPage,
    tagStr,
    setTagStr,
    tags,
    setTags,
    images,
    setImages,
    image1,
    setImage1,
    previewImage1,
    setPreviewImage1,
    image2,
    setImage2,
    previewImage2,
    setPreviewImage2,
    image3,
    setImage3,
    previewImage3,
    setPreviewImage3,
    image4,
    setImage4,
    previewImage4,
    setPreviewImage4,
    image5,
    setImage5,
    previewImage5,
    setPreviewImage5,
    stealthMode,
    setStealthMode,
    stealthModeStr,
    setStealthModeStr,
    gochiRestriction,
    setGochiRestriction,
    gochiRestrictionStr,
    setGochiRestrictionStr,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    cognitoUserId,
    setCognitoUserId,
    forcePassChanged,
    email,
    updateOpenShopAdd,
    updateOpenShopAddConfirm,
    shopCategories,
    shopCategoryId,
    setShopCategoryId,
    numberSit,
    setNumberSit,
    smoking,
    setSmoking,
    parking,
    setParking,
    snsFacebook,
    setSnsFacebook,
    setSnsTwitter,
    snsTwitter,
    setSnsInstagram,
    snsInstagram,
    shopNameError,
    setShopNameError,
    shopNameKanaError,
    setShopNameKanaError,
    zipCodeError,
    setZipCodeError,
    prefecturesError,
    setPrefecturesError,
    cityError,
    // setCityError,
    // addressError,
    // setAddressError,
    address1Error,
    setAddress1Error,
    address2Error,
    setAddress2Error,
    cityIdError,
    setCityIdError,
    // cityError,
    // setCityError,
    contactPhoneError,
    setContactPhoneError,
    phoneError,
    setPhoneError,
    tagError,
    setTagError,
    bankNameError,
    setBankNameError,
    bankBranchNameError,
    setBankBranchNameError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    consent,
    setConsent,
    consentStep2,
    setConsentStep2,
    shopCategoriesError,
    setShopCategoriesError,
    snsFacebookError,
    setSnsFacebookError,
    snsTwitterError,
    setSnsTwitterError,
    snsInstagramError,
    setSnsInstagramError,
    shopContactNameError,
    shopGroupNameError,
    departmentError,
    setShopContactNameError,
    setShopGroupNameError,
    setDepartmentError,
    paymentGroupType,
    showPhone,
    cashAllowed,
    setCashAllowed,
    allowMenuPriceShashoku,
    setAllowMenuPriceShashoku,
    reGetAccounts,
    showRequire,
    setShowRequire,
    inviteUser,
    setInviteUser
  }) => {
    const enableShopBank = paymentGroupType === null;
    const addConfirm = {
      shopName,
      shopNameKana,
      zipCode,
      prefectureCode,
      city,
      // address,
      // cityName,
      building,
      shopGroupName,
      shopContactName,
      department,
      contactPhone,
      phone,
      businessHours,
      introduction,
      holiday,
      nearestStation,
      priceRange,
      access,
      webPage,
      tagStr,
      previewImage1,
      previewImage2,
      previewImage3,
      previewImage4,
      previewImage5,
      stealthModeStr,
      gochiRestrictionStr,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      shopCategoryId,
      numberSit,
      smoking,
      parking,
      snsFacebook,
      snsTwitter,
      snsInstagram,
      showPhone,
      address1,
      address2,
      cashAllowed,
      allowMenuPriceShashoku
    };
    const bankAccount = {
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountNumber,
      bankAccountHolder
    };
    const addParam = {
      preShopId,
      unregistered,
      shopName,
      shopNameKana,
      zipCode,
      prefectureCode,
      city,
      // address,
      // cityName,
      cityId,
      building,
      shopGroupName,
      shopContactName,
      department,
      contactPhone,
      phone,
      businessHours,
      introduction,
      holiday,
      nearestStation,
      priceRange,
      access,
      webPage,
      tags,
      images,
      stealthMode,
      gochiRestriction,
      depositManage,
      bankAccount,
      cognitoUserId,
      forcePassChanged,
      email,
      shopCategoryId,
      numberSit,
      smoking,
      parking,
      snsFacebook,
      snsTwitter,
      snsInstagram,
      showPhone,
      address1,
      address2,
      cashAllowed,
      shopDetail: {
        allowMenuPriceShashoku,
        inviteUser: inviteUser ? inviteUser.trim() : ''
      },
      isShopCanEditSetting: 1
    };

    const errors = {
      shopNameError,
      shopNameKanaError,
      zipCodeError,
      prefecturesError,
      cityError,
      // addressError,
      // cityError,
      cityIdError,
      contactPhoneError,
      phoneError,
      tagError,
      bankNameError,
      bankBranchNameError,
      bankAccountNumberError,
      bankAccountHolderError,
      shopCategoriesError,
      snsFacebookError,
      snsTwitterError,
      snsInstagramError,
      shopContactNameError,
      shopGroupNameError,
      departmentError,
      address1Error,
      address2Error
    };

    const checkCityName = () => {
      console.log('city', city);
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === city)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        return Number(chosenCityNameList[0].value);
      }
      return Number(0);
    };

    useEffect(() => {
      setCityId(checkCityName());
    }, [city]);

    const getZipCodeData = async zipcode => {
      await actions.getZipCode(zipcode).then(data => {
        setPrefectureCode(data.payload.prefectureCode);
        setCity(data.payload.city ? data.payload.city : 0);
        // setAddress(data.payload.address ? data.payload.address : '');
        setAddress1(data.payload.address1 ? data.payload.address1 : '');
        // setAddress2(data.payload.address2 ? data.payload.address2 : '');
        checkCityName();
      });
    };

    const validShopName = () => {
      const value = shopName ? shopName.trim() : '';
      if (value === '') {
        setShopNameError('必須項目です。');
        return 1;
      }
      setShopNameError('');
      setShopName(value);
      return 0;
    };
    const validShopNameCount = async () => {
      const value = shopName ? shopName.trim() : '';
      if (!preShopId && value !== '') {
        const nameData = await actions
          .countPreShopName({
            preShopNameMatch: value,
            includeUnregisteredShop: true
          })
          .then();
        if (nameData.payload.totalCount > 0) {
          setShopNameError(
            '同様の名前の店舗が仮登録されています。お手数ですが前画面に戻り、そちらから登録ください。'
          );
          return 1;
        }
      }
      return 0;
    };

    const validShopNameKana = () => {
      const value = shopNameKana ? shopNameKana.trim() : '';
      if (value === '') {
        setShopNameKanaError('必須項目です。');
        return 1;
      }
      if (!/^[\u3040-\u309F\s\d０-９ー]+$/.test(value)) {
        setShopNameKanaError('ひらがなで入力してください。');
        return 1;
      }
      setShopNameKanaError('');
      setShopNameKana(value);
      return 0;
    };
    const validZipCode = () => {
      const value = zipCode ? zipCode.trim() : '';
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      getZipCodeData(value);
      return 0;
    };
    const validZipCodeSubmit = () => {
      const value = zipCode ? zipCode.trim() : '';
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      return 0;
    };
    const validPrefectures = () => {
      const value = prefectureCode;
      if (value === 0) {
        setPrefecturesError('必須項目です。');
        return 1;
      }
      setPrefecturesError('');
      setPrefectureCode(value);
      return 0;
    };
    const validCityId = () => {
      const value = cityId;
      if (value === 0) {
        setCityIdError('必須項目です。');
        return 1;
      }
      setCityIdError('');
      setCityId(value);
      return 0;
    };
    const setCityNameData = id => {
      cities.forEach(item => {
        if (id === item.cityId) {
          setCity(item.cityName);
        }
      });
    };
    const validShopCategories = () => {
      const value = shopCategoryId;
      if (value === 0) {
        setShopCategoriesError('必須項目です。');
        return 1;
      }
      setShopCategoriesError('');
      setShopCategoryId(value);
      return 0;
    };
    const validSnsFacebook = () => {
      const value = snsFacebook;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsFacebookError('URLを入力してください');
        return 1;
      }
      setSnsFacebookError('');
      setSnsFacebook(value);
      return 0;
    };
    const validSnsTwitter = () => {
      const value = snsTwitter;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsTwitterError('URLを入力してください');
        return 1;
      }
      setSnsTwitterError('');
      setSnsTwitter(value);
      return 0;
    };
    const validSnsInstagram = () => {
      const value = snsInstagram;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setSnsInstagramError('URLを入力してください');
        return 1;
      }
      setSnsInstagramError('');
      setSnsInstagram(value);
      return 0;
    };
    // const validAddress = () => {
    //   const value = address ? address.trim() : '';
    //   if (value === '') {
    //     setAddressError('必須項目です。');
    //     return 1;
    //   }
    //   setAddressError('');
    //   setAddress(value);
    //   return 0;
    // };
    const validAddress1 = () => {
      const value = address1 ? address1.trim() : '';
      if (value === '') {
        setAddress1Error('必須項目です。');
        return 1;
      }
      setAddress1Error('');
      setAddress1(value);
      return 0;
    };
    const validAddress2 = () => {
      const value = address2 ? address2.trim() : '';
      if (value === '') {
        setAddress2Error('必須項目です。');
        return 1;
      }
      setAddress2Error('');
      setAddress2(value);
      return 0;
    };
    const validShopContactName = () => {
      const value = shopContactName ? shopContactName.trim() : '';
      if (value === '') {
        setShopContactNameError('必須項目です。');
        return 1;
      }
      setShopContactNameError('');
      setShopContactName(value);
      return 0;
    };
    const validShopGroupName = () => {
      const value = shopGroupName ? shopGroupName.trim() : '';
      if (value === '') {
        setShopGroupNameError('必須項目です。');
        return 1;
      }
      setShopGroupNameError('');
      setShopGroupName(value);
      return 0;
    };
    const validDepartment = () => {
      const value = department ? department.trim() : '';
      if (value === '') {
        setDepartmentError('必須項目です。');
        return 1;
      }
      setDepartmentError('');
      setDepartment(value);
      return 0;
    };
    const validContactPhone = () => {
      const value = contactPhone ? contactPhone.trim() : '';
      if (value === '') {
        setContactPhoneError('必須項目です。');
        return 1;
      }
      if (value !== '' && !/^\d+$/.test(value)) {
        setContactPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setContactPhoneError('');
      setContactPhone(value);
      return 0;
    };
    const validPhone = () => {
      const value = phone ? phone.trim() : '';
      if (value === '') {
        setPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setPhoneError('');
      setPhone(value);
      return 0;
    };
    const validPhoneCount = async () => {
      const value = phone ? phone.trim() : '';
      if (!preShopId && value !== '') {
        const phoneData = await actions
          .countPreShopPhone({
            phone: value,
            includeUnregisteredShop: true
          })
          .then();
        if (phoneData.payload.totalCount > 0) {
          setPhoneError(
            '同様の電話番号の店舗が仮登録されています。お手数ですが前画面に戻りそちらから登録ください。'
          );
          return 1;
        }
      }
      return 0;
    };
    const validTag = () => {
      const value = tagStr.trim();
      if (
        value !== '' &&
        tags
          .map(tag => {
            if (tag.tagName.length > 30) {
              return 1;
            }
            return 0;
          })
          .includes(1)
      ) {
        setTagError(
          '1つのタグは30文字以内で入力してください。タグとタグの間はスペースで区切ってください。'
        );
        return 1;
      }
      setTagError('');
      setTagStr(value);
      return 0;
    };
    const validBankName = () => {
      const value = bankName ? bankName.trim() : '';
      if (enableShopBank && depositManage === 'NONSELF' && value === '') {
        setBankNameError('必須項目です。');
        return 1;
      }
      setBankNameError('');
      setBankName(value);
      return 0;
    };
    const validBankBranchName = () => {
      const value = bankBranchName ? bankBranchName.trim() : '';
      if (enableShopBank && depositManage === 'NONSELF' && value === '') {
        setBankBranchNameError('必須項目です。');
        return 1;
      }
      setBankBranchNameError('');
      setBankBranchName(value);
      return 0;
    };
    const validBankAccountNumber = () => {
      const value = bankAccountNumber ? bankAccountNumber.trim() : '';
      if (enableShopBank && depositManage === 'NONSELF') {
        if (value === '') {
          setBankAccountNumberError('必須項目です。');
          return 1;
        }
        if (!/^\d{7}$/.test(value)) {
          setBankAccountNumberError('半角数字のみで7桁で入力してください。');
          return 1;
        }
      }
      setBankAccountNumberError('');
      setBankAccountNumber(value);
      return 0;
    };
    const validBankAccountHolder = () => {
      const value = bankAccountHolder ? bankAccountHolder.trim() : '';
      if (enableShopBank && depositManage === 'NONSELF') {
        if (value === '') {
          setBankAccountHolderError('必須項目です。');
          return 1;
        }
        if (
          !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
            value
          )
        ) {
          setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
          return 1;
        }
      }
      setBankAccountHolderError('');
      setBankAccountHolder(value);
      return 0;
    };
    const valid = async () => {
      let errorCount =
        validShopName() +
        validShopNameKana() +
        validZipCodeSubmit() +
        validPrefectures() +
        validAddress1() +
        validAddress2() +
        validCityId() +
        validContactPhone() +
        validPhone() +
        validTag() +
        validBankName() +
        validBankBranchName() +
        validBankAccountNumber() +
        validBankAccountHolder() +
        validShopCategories() +
        validSnsFacebook() +
        validSnsTwitter() +
        validSnsInstagram() +
        validShopContactName() +
        validShopGroupName() +
        validDepartment();

      await Promise.all([validShopNameCount(), validPhoneCount()]).then(
        values => {
          errorCount += values[0] + values[1];
        }
      );
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };
    const convertStealthModeStr = mode => {
      if (mode === 'UNSTEALTH') {
        setStealthModeStr('表示');
      } else {
        setStealthModeStr('非表示');
      }
    };
    const convertGochiRestrictionStr = mode => {
      if (mode === 'MENTION_ONLY') {
        setGochiRestrictionStr('指名ごちのみ');
      } else {
        setGochiRestrictionStr('制限なし');
        setGochiRestrictionStr('制限なし');
      }
    };
    const convertDepositManageStr = mode => {
      if (mode === 'SELF') {
        setDepositManageStr('Stripe経由で受取（週1回入金）');
      } else {
        setDepositManageStr('銀行口座で直接受取（月1回入金）（オプション）');
      }
    };
    const convertBankAccountTypeStr = mode => {
      if (mode === 'SAVINGS') {
        setBankAccountTypeStr('普通預金');
      } else {
        setBankAccountTypeStr('当座預金');
      }
    };
    const convertImages = () => {
      const imageArray = {
        0: {
          image: image1,
          imagePath: previewImage1
        },
        1: {
          image: image2,
          imagePath: previewImage2
        },
        2: {
          image: image3,
          imagePath: previewImage3
        },
        3: {
          image: image4,
          imagePath: previewImage4
        },
        4: {
          image: image5,
          imagePath: previewImage5
        }
      };
      setImages(imageArray);
    };

    const confirmAction = () => {
      valid().then(validCheckOK => {
        if (!validCheckOK) {
          alert('登録情報を正しく入力してください。');
          setShowRequire(true);
        } else {
          setCityNameData(cityId);
          convertImages();
          updateOpenShopAddConfirm(true);
        }
      });
    };

    const getCitiesOptions = () => {
      const citiesOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (!prefectureCode || prefectureCode === 0) {
        cities.forEach(item => {
          citiesOptions.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      } else {
        cities
          .filter(
            item =>
              item.prefCode && Number(item.prefCode) === Number(prefectureCode)
          )
          .forEach(item => {
            citiesOptions.push({
              label: item.cityName,
              value: String(item.cityId)
            });
          });
      }
      return { ...citiesOptions, tmpObj };
    };

    const handleNext = () => {
      setShowRequire(false);
      const table = document.getElementById('scrollTableAdd');
      if (table !== null) {
        table.scrollTop = 0;
      }
    };

    const handleBack = () => {
      setShowRequire(true);
      const table = document.getElementById('scrollTableAdd');
      if (table !== null) {
        table.scrollTop = 0;
      }
    };

    return (
      <div className={classes.root} id="scrollTableAdd">
        <div className={classes.pageTitle}>
          <Typography variant="h5">
            {showRequire ? '新規店舗登録 (必須)' : '新規店舗登録 (任意)'}
          </Typography>
          <Typography className={classes.description}>
            店舗情報を入力してください。
            <br />
            「任意」の情報も入力すると、お客さまに詳しい情報を伝えることができます。
            <br />
            <br />
            ※登録公開後も情報の変更ができます。
          </Typography>
        </div>
        {/* {showRequire ? ( */}
        <div style={{ display: showRequire ? 'inherit' : 'none' }}>
          <Paper
            id="scrollTableRequire"
            className={classes.mainPaper}
            elevation={1}
          >
            <Table className={classes.editTable}>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    required
                    label="店舗名"
                    defaultValue={detail.preShopName}
                    placeholder="ごち屋　天神店"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    name="shopName"
                    onChange={e => {
                      setShopName(e.target.value);
                    }}
                    onBlur={() => {
                      validShopName();
                      validShopNameCount();
                    }}
                  />
                  <ValidationText message={errors.shopNameError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    required
                    label="店舗名かな"
                    placeholder="ごちや　てんじんてん"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    name="nameKana"
                    onChange={e => {
                      setShopNameKana(e.target.value);
                    }}
                    onBlur={validShopNameKana}
                  />
                  <ValidationText message={errors.shopNameKanaError} />
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="郵便番号"
                    defaultValue={detail.zipCode}
                    fullWidth
                    className={classes.textField}
                    placeholder="0001111"
                    margin="normal"
                    name="zipCode"
                    onChange={e => {
                      setZipCode(e.target.value);
                    }}
                    onBlur={validZipCode}
                  />
                  <Typography variant="h7" className={classes.font12}>
                    ハイフンなしで記載ください
                  </Typography>
                  <ValidationText message={errors.zipCodeError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    select
                    fullWidth
                    label="都道府県"
                    className={classes.textField}
                    margin="normal"
                    value={prefectureCode}
                    name="prefectureCode"
                    onChange={e => {
                      setPrefectureCode(e.target.value);
                      setCityId(Number(0));
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onBlur={validPrefectures}
                  >
                    {prefectures.map(item => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                  <ValidationText message={errors.prefecturesError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <ReactSelectMaterialUi
                    disabled={!prefectureCode || prefectureCode <= 0}
                    required
                    fullWidth
                    label="市区町村*"
                    className={classes.textField}
                    defaultValue={String(cityId)}
                    value={String(cityId)}
                    options={getCitiesOptions()}
                    margin="normal"
                    name="cityId"
                    onChange={e => {
                      setCityId(Number(e));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validCityId}
                  />
                  <ValidationText message={errors.cityError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="町名"
                    defaultValue={detail.address1}
                    placeholder="天神"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    value={address1}
                    name="address1"
                    onChange={e => {
                      setAddress1(e.target.value);
                    }}
                    onBlur={validAddress1}
                  />
                  <ValidationText message={errors.address1Error} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="番地"
                    defaultValue={detail.address2}
                    placeholder="1-2-3"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    value={address2}
                    name="address2"
                    onChange={e => {
                      setAddress2(e.target.value);
                    }}
                    onBlur={validAddress2}
                  />
                  <ValidationText message={errors.address2Error} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="建物名"
                    defaultValue={detail.building}
                    placeholder="○○ビル 102号"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    name="building"
                    onChange={e => {
                      setBuilding(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    required
                    select
                    label="店舗カテゴリー"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    value={shopCategoryId}
                    name="shopCategoryId"
                    onChange={e => {
                      setShopCategoryId(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onBlur={validShopCategories}
                  >
                    {shopCategories.map(item => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                  <ValidationText message={errors.shopCategoriesError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[
                    classes.tableCellBorderNone,
                    classes.colRight,
                    classes.font12
                  ]}
                >
                  店舗オーナーさまへの依頼）
                  <br />
                  店舗オーナーさまが登録された店舗の現場に連絡しても、
                  「ごちめし」のことを全く知らないという事例が発生してきています。
                  店舗登録時には現場の責任者に了解を取った後に登録ください。
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="運営会社名"
                    defaultValue={detail.shopGroupName}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    name="shopGroupName"
                    onChange={e => {
                      setShopGroupName(e.target.value);
                    }}
                    onBlur={validShopGroupName}
                  />
                  <Typography variant="h7" className={classes.font12}>
                    個人店の場合は「なし」と記載ください
                  </Typography>
                  <ValidationText message={errors.shopGroupNameError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="ご担当者名"
                    defaultValue={detail.shopContactName}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    name="shopContactName"
                    onChange={e => {
                      setShopContactName(e.target.value);
                    }}
                    onBlur={validShopContactName}
                  />
                  <ValidationText message={errors.shopContactNameError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="所属部署"
                    defaultValue={detail.department}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    name="department"
                    onChange={e => {
                      setDepartment(e.target.value);
                    }}
                    onBlur={validDepartment}
                  />
                  <Typography variant="h7" className={classes.font12}>
                    個人店の場合は「なし」と記載ください
                  </Typography>
                  <ValidationText message={errors.departmentError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <TextField
                    required
                    label="電話番号（担当者）"
                    defaultValue={detail.contactPhone}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    name="contactPhone"
                    onChange={e => {
                      setContactPhone(e.target.value);
                    }}
                    onBlur={validContactPhone}
                  />
                  <Typography variant="h7" className={classes.font12}>
                    ハイフンなしで記載ください
                  </Typography>
                  <ValidationText message={errors.contactPhoneError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell>
                  <TextField
                    required
                    label="店舗電話番号"
                    defaultValue={detail.phone}
                    placeholder="09012345678"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    name="phone"
                    onChange={e => {
                      setPhone(e.target.value);
                    }}
                    onBlur={() => {
                      validPhone();
                      validPhoneCount();
                    }}
                  />
                  <Typography variant="h7" className={classes.font12}>
                    ハイフンなしで記載ください
                  </Typography>
                  <ValidationText message={errors.phoneError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell>
                  <TextField
                    disabled
                    required
                    label="メールアドレス"
                    defaultValue={email}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    name="accemail"
                  />
                  <Typography variant="h7" className={classes.font12}>
                    メールアドレスは、ごちめしの各種ご連絡、および、管理システムのIDとしても利用いたします。
                    メールアドレスの変更を行いたい場合には、画面右上のメニュー(人マーク)の「メールアドレス変更」より行ってください。
                    <br />
                    <span className={classes.desEmail}>
                      注意：グループ管理者の方は一度ログアウトし、各店舗のID・パスワードで店舗管理者として再度ログイン後、ご変更ください。
                    </span>
                  </Typography>
                  <ValidationText message={errors.phoneError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <Typography className={classes.description}>
                    店舗詳細表示制限
                  </Typography>
                  <RadioGroup
                    row
                    value={stealthMode}
                    onChange={e => {
                      setStealthMode(e.target.value);
                      convertStealthModeStr(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="UNSTEALTH"
                      control={<Radio color="primary" />}
                      label="店舗詳細表示"
                    />
                    <FormControlLabel
                      value="STEALTH"
                      control={<Radio color="primary" />}
                      label="店舗詳細非表示"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.font12}>
                  非表示を選択した場合は、ごちめしアプリに店舗の詳細情報が表示されません。
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <Typography className={classes.description}>
                    誰でもごち制限
                  </Typography>
                  <RadioGroup
                    row
                    value={gochiRestriction}
                    onChange={e => {
                      setGochiRestriction(e.target.value);
                      convertGochiRestrictionStr(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="MENTION_ONLY"
                      control={<Radio color="primary" />}
                      label="指名ごちのみ"
                    />
                    <FormControlLabel
                      value="ANY"
                      control={<Radio color="primary" />}
                      label="制限なし"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.font12}>
                  指名ごちのみを選択した場合は、利用者を指名したごちのみ利用可能となります。
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <Typography className={classes.description}>
                    社食ごちめし現金授受の有無
                  </Typography>
                  <RadioGroup
                    row
                    value={cashAllowed}
                    onChange={e => {
                      const allowed = parseInt(e.target.value, 10);
                      setCashAllowed(allowed);
                    }}
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="受け付けない"
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="受け付ける"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <Typography className={classes.description}>
                    社食ごちめし金額指定チケット利用の有無
                  </Typography>
                  <RadioGroup
                    row
                    value={allowMenuPriceShashoku}
                    onChange={e => {
                      setAllowMenuPriceShashoku(parseInt(e.target.value, 10));
                    }}
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="利用する"
                    />
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="利用しない"
                    />
                  </RadioGroup>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.font12}>
                  ごちめしへの参加を促してくれたユーザーで、店舗の仮登録をしてくれたユーザーを指します。
                </TableCell>
              </TableRow>
            </Table>

            <TableRow>
              <TableCell
                className={[classes.tableCellBorderNone, classes.colLeft]}
              >
                <RequiredButton />
              </TableCell>
              <TableCell
                component="p"
                className={[classes.tableCellBorderNone, classes.colRight]}
              >
                <Typography className={classes.description}>
                  売上受取方法
                </Typography>
                {!enableShopBank && (
                  <Typography className={classes.descriptionSmall}>
                    ※貴グループ運営会社で銀行口座情報がすでに登録されているため、店舗ごとの入金管理の登録は不要です。
                  </Typography>
                )}
                <RadioGroup
                  value={!enableShopBank ? 'NOT_MANAGE' : depositManage}
                  onChange={e => {
                    setDepositManage(e.target.value);
                    convertDepositManageStr(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="SELF"
                    control={
                      <Radio color="primary" disabled={!enableShopBank} />
                    }
                    label="Stripe経由で受取（週1回入金）"
                  />
                  <span className={classes.font12}>
                    第3者の決済サービス（Stripe
                    Connect）を利用して、支払いサイト(基本は週次)を変更したり、振込手数料を無料にする事ができます。
                  </span>
                  <br />
                  <FormControlLabel
                    value="NONSELF"
                    control={
                      <Radio color="primary" disabled={!enableShopBank} />
                    }
                    label="銀行口座で直接受取（月1回入金）（オプション）"
                  />
                  <span className={classes.font12}>
                    月末締め翌月5営業日以内に当社より振込みいたします（振込手数料は貴社負担）。
                    <br />
                    後から「自社で入金を管理する」へ変更することも可能です。
                  </span>
                </RadioGroup>
              </TableCell>
            </TableRow>

            {depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="銀行名"
                    placeholder="○○銀行"
                    disabled={!enableShopBank}
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankName(e.target.value);
                    }}
                    onBlur={validBankName}
                  />
                  <ValidationText message={errors.bankNameError} />
                </TableCell>
                <TableCell className={classes.tableCellBorderNone} />
              </TableRow>
            )}
            {depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="支店名"
                    placeholder="○○支店"
                    disabled={!enableShopBank}
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankBranchName(e.target.value);
                    }}
                    onBlur={validBankBranchName}
                  />
                  <ValidationText message={errors.bankBranchNameError} />
                </TableCell>
                <TableCell className={classes.tableCellBorderNone} />
              </TableRow>
            )}
            {depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <Typography className={classes.description}>
                    口座種別
                  </Typography>
                  <RadioGroup
                    row
                    value={bankAccountType}
                    onChange={e => {
                      setBankAccountType(e.target.value);
                      convertBankAccountTypeStr(e.target.value);
                    }}
                  >
                    <FormControlLabel
                      value="SAVINGS"
                      control={
                        <Radio color="primary" disabled={!enableShopBank} />
                      }
                      label="普通預金"
                    />
                    <FormControlLabel
                      value="CHECKING"
                      control={
                        <Radio color="primary" disabled={!enableShopBank} />
                      }
                      label="当座預金"
                    />
                  </RadioGroup>
                </TableCell>
                <TableCell className={classes.tableCellBorderNone} />
              </TableRow>
            )}
            {depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="口座番号"
                    placeholder="1234567"
                    disabled={!enableShopBank}
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankAccountNumber(e.target.value);
                    }}
                    onBlur={validBankAccountNumber}
                  />
                  <ValidationText message={errors.bankAccountNumberError} />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  半角数字・7桁（6桁以下の方は先頭に0をつけて7桁にしてください）
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'NONSELF' && (
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    label="口座名義"
                    placeholder="ヤマダ　タロウ"
                    disabled={!enableShopBank}
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBankAccountHolder(e.target.value);
                    }}
                    onBlur={validBankAccountHolder}
                  />
                  <ValidationText message={errors.bankAccountHolderError} />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  必ず漢字/ひらがな以外でご記入ください。
                </TableCell>
              </TableRow>
            )}
            {depositManage === 'SELF' && (
              <TableRow>
                <TableCell className={[classes.colRight, classes.font12]}>
                  <Divider />
                  <br />
                  第3者の決済サービス「Stripe&nbsp;Connect」を利用して頂く事で、自社で入金サイクル（基本は毎週）を変更したり、振込手数料を無料にする事ができます。こちらのオプションを選んだ場合は、以下の設定を行って頂きます。
                  <br />
                  <br />
                  ①&nbsp;Stripeでアカウントを作成する。
                  <br />
                  ②&nbsp;ごちめしを運営する当社のStripeアカウントに紐付けを行う。
                  <br />
                  ③&nbsp;初回入金時に、Stripe社より送られる案内メールにしたがって、本人確認資料を提出する。
                  <br />
                  <br />
                  管理画面左上の三本線メニューから、「その他」→「自社で入金管理（オプション）」を選んで頂くと、上記の①および②の設定が一度に行う事ができます。設定の詳細については、当管理システムのトップページから「ごちめし店舗登録マニュアルはこちら」をご参照ください。
                </TableCell>
              </TableRow>
            )}
            <Divider />
            <br />
            <Table className={classes.editTable}>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={consent}
                        onChange={e => {
                          setConsent(e.target.checked);
                        }}
                        color="primary"
                      />
                    }
                    label={
                      <span className={classes.font12}>
                        ごちめし加盟店規約に同意する
                      </span>
                    }
                  />
                </TableCell>
              </TableRow>
            </Table>
          </Paper>
          <Divider />
          <div className={classes.clsActions}>
            <CancelButton onClickAction={cancelAction} color="primary" />
            <Button
              variant="contained"
              disabled={!consent}
              color="primary"
              onClick={handleNext}
              className={classes.button}
            >
              次へ
            </Button>
          </div>
        </div>
        {/* ) : ( */}
        <div style={{ display: !showRequire ? 'inherit' : 'none' }}>
          <Paper
            id="scrollTableAny"
            className={classes.mainPaper}
            elevation={1}
          >
            <Table className={classes.editTable}>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="店舗概要"
                    placeholder="創業年、お店の特徴、雰囲気　など"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setIntroduction(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="営業時間"
                    defaultValue={businessHours}
                    placeholder="平日11：00～14：00 （LO 13：30）/土日祝11：00～14：00 （LO 13：30）"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBusinessHours(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="定休日"
                    defaultValue={holiday}
                    placeholder="第2・第4土曜、日曜、祝日"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setHoliday(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="価格帯"
                    placeholder="○○～○○円"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setPriceRange(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="最寄り駅"
                    placeholder="○○線○○駅"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setNearestStation(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="アクセス"
                    defaultValue={detail.access}
                    placeholder="（交通手段、最寄り駅など）より○○分"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setAccess(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="WebページURL"
                    defaultValue={detail.webPage}
                    placeholder="https://www.test.com/"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setWebPage(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <AnyButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    label="タグ"
                    defaultValue={tagStr}
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setTagStr(e.target.value);
                      splitTagStr(e.target.value);
                    }}
                    onBlur={validTag}
                  />
                  <ValidationText message={errors.tagError} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.font12}>
                  #イタリアン #飲み会に #港区 など、半角の#をつけて
                  <span className={classes.tagCaution}>
                    スペースで区切ってください。
                  </span>
                  <br />
                  店舗のカテゴリー・特徴・売りなどをこちらのタグで表現して頂きます。
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <AnyButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <FileUpload
                    label="image1"
                    setFile={setImage1}
                    previewImage={previewImage1}
                    setPreviewImage={setPreviewImage1}
                  />
                  <FileUpload
                    label="image2"
                    setFile={setImage2}
                    previewImage={previewImage2}
                    setPreviewImage={setPreviewImage2}
                  />
                  <FileUpload
                    label="image3"
                    setFile={setImage3}
                    previewImage={previewImage3}
                    setPreviewImage={setPreviewImage3}
                  />
                  <FileUpload
                    label="image4"
                    setFile={setImage4}
                    previewImage={previewImage4}
                    setPreviewImage={setPreviewImage4}
                  />
                  <FileUpload
                    label="image5"
                    setFile={setImage5}
                    previewImage={previewImage5}
                    setPreviewImage={setPreviewImage5}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.font12}>
                  画像は１枚につき8MB以内でお願いします。
                  <br />
                  画像は５枚まで登録できます。複数枚登録した場合は、店舗詳細画面でスライド表示されます。
                  <br />
                  店舗一覧には１番目に登録した画像が表示されます。
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <div className={classes.margin}>
                    <Grid container spacing={1} alignItems="flex-end">
                      <Grid item xs={12} sm container>
                        <TextField
                          label="Facebook"
                          placeholder="https://www.facebook.com/---"
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            setSnsFacebook(e.target.value);
                          }}
                          onBlur={validSnsFacebook}
                        />
                      </Grid>
                    </Grid>
                    <ValidationText message={errors.snsFacebookError} />
                    <Grid container spacing={1} alignItems="flex-end">
                      <Grid item xs={12} sm container>
                        <TextField
                          label="Twitter"
                          placeholder="https://www.twitter.com/---"
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            setSnsTwitter(e.target.value);
                          }}
                          onBlur={validSnsTwitter}
                        />
                      </Grid>
                    </Grid>
                    <ValidationText message={errors.snsTwitterError} />
                    <Grid container spacing={1} alignItems="flex-end">
                      <Grid item xs={12} sm container>
                        <TextField
                          label="Instagram"
                          placeholder="https://www.instagram.com/---"
                          fullWidth
                          className={classes.textField}
                          margin="normal"
                          onChange={e => {
                            setSnsInstagram(e.target.value);
                          }}
                          onBlur={validSnsInstagram}
                        />
                      </Grid>
                    </Grid>
                    <ValidationText message={errors.snsInstagramError} />
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="座席"
                    placeholder="カウンター○席、個室○室"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setNumberSit(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="禁煙/喫煙"
                    placeholder=""
                    className={classes.textField}
                    fullWidth
                    margin="normal"
                    onChange={e => {
                      setSmoking(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="駐車場"
                    placeholder="お店から徒歩○分に〇台"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setParking(e.target.value);
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <AnyButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    label="ごちめしの紹介者"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    value={inviteUser}
                    inputProps={{
                      maxLength: 255
                    }}
                    onChange={e => {
                      setInviteUser(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.font12}>
                  ごちめしへの参加を促してくれたユーザーで、店舗の仮登録をしてくれたユーザーを指します。
                </TableCell>
              </TableRow>
            </Table>
            <br />
            <Table className={classes.editTable}>
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={consentStep2}
                        onChange={e => {
                          setConsentStep2(e.target.checked);
                        }}
                        color="primary"
                      />
                    }
                    label={
                      <span className={classes.font12}>
                        ごちめし加盟店規約に同意する
                      </span>
                    }
                  />
                </TableCell>
              </TableRow>
            </Table>
          </Paper>
          <Divider />
          <div className={classes.clsActions}>
            <Button color="primary" onClick={handleBack}>
              戻る
            </Button>
            <ConfirmButton
              onClickAction={confirmAction}
              consent={showRequire ? consent : consentStep2}
            />
          </div>
        </div>
        {/* )} */}

        <Modal open={openShopAddConfirm} className={classes.modalMobile}>
          <ShopAddConfirm
            updateOpenShopAdd={updateOpenShopAdd}
            updateOpenShopAddConfirm={updateOpenShopAddConfirm}
            backAction={backAction}
            registerAction={registerAction}
            addConfirm={addConfirm}
            addParam={addParam}
            shopId={shopId}
            prefectures={prefectures}
            setCognitoUserId={setCognitoUserId}
            shopCategories={shopCategories}
            enableShopBank={enableShopBank}
            reGetAccounts={reGetAccounts}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
